import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      position="top-center"
      closeButton={false}
      richColors={true}
      offset={0}
      gap={4}
      expand={false}
      visibleToasts={2}
      toastOptions={{
        duration: 2500,
        style: {
          pointerEvents: 'none',
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-black/70 group-[.toaster]:backdrop-blur-md group-[.toaster]:text-white group-[.toaster]:border-none group-[.toaster]:shadow-none group-[.toaster]:text-xs group-[.toaster]:py-1.5 group-[.toaster]:px-3 group-[.toaster]:rounded-full group-[.toaster]:w-auto group-[.toaster]:max-w-[280px] group-[.toaster]:mx-auto group-[.toaster]:pointer-events-none",
          description: "group-[.toast]:text-white/60 group-[.toast]:text-[10px]",
          actionButton:
            "group-[.toast]:bg-babylon-gold group-[.toast]:text-babylon-void",
          cancelButton:
            "group-[.toast]:bg-transparent group-[.toast]:text-white/40",
          closeButton: "hidden",
        },
      }}
      style={{ top: '45vh', pointerEvents: 'none' }}
      {...props} />
  );
}

export { Toaster, toast }
